// DOM query cache to avoid repeated queries
export class DOMCache {
  constructor() {
    this.cache = new Map();
  }

  get(selector, forceRefresh = false) {
    if (forceRefresh || !this.cache.has(selector)) {
      const element = document.querySelector(selector);
      if (element) {
        this.cache.set(selector, element);
      }
      return element;
    }
    return this.cache.get(selector);
  }

  getAll(selector, forceRefresh = false) {
    const key = `all:${selector}`;
    if (forceRefresh || !this.cache.has(key)) {
      const elements = document.querySelectorAll(selector);
      this.cache.set(key, elements);
      return elements;
    }
    return this.cache.get(key);
  }

  clear() {
    this.cache.clear();
  }

  remove(selector) {
    this.cache.delete(selector);
    this.cache.delete(`all:${selector}`);
  }
}

// Global DOM cache instance
export const domCache = new DOMCache();

// Batch DOM updates to minimize reflows
export function batchDOMUpdate(callback) {
  requestAnimationFrame(() => {
    callback();
  });
}

export function setElementVisibility(selector, visible) {
  const element = domCache.get(selector);
  if (element) {
    element.style.display = visible ? '' : 'none';
  }
}
